/** Two rising notes, so the test reads as a chime rather than a beep. */
const NOTES = [
  { frequency: 660, start: 0 },
  { frequency: 880, start: 0.18 },
]
const NOTE_SECONDS = 0.35

/**
 * Plays a short chime through the default output, for the speaker test in the device check
 * (SC-438). Built with Web Audio, so no sound file ships. Resolves when it has finished.
 */
export async function playSpeakerTest(): Promise<void> {
  const AudioContextCtor =
    window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!AudioContextCtor) return

  const context = new AudioContextCtor()
  const now = context.currentTime
  for (const { frequency, start } of NOTES) {
    const oscillator = context.createOscillator()
    const gain = context.createGain()
    oscillator.type = 'sine'
    oscillator.frequency.value = frequency
    // A quick fade in and out avoids clicks at the start and end of each note.
    gain.gain.setValueAtTime(0, now + start)
    gain.gain.linearRampToValueAtTime(0.25, now + start + 0.02)
    gain.gain.linearRampToValueAtTime(0, now + start + NOTE_SECONDS)
    oscillator.connect(gain).connect(context.destination)
    oscillator.start(now + start)
    oscillator.stop(now + start + NOTE_SECONDS)
  }
  const totalMs = (NOTES[NOTES.length - 1].start + NOTE_SECONDS) * 1000
  await new Promise((resolve) => setTimeout(resolve, totalMs + 50))
  await context.close()
}
